(function () {
  // Dwie lataki na zachowanie motywu i aplikacji AOV, trzymane poza glownym
  // skryptem szuflady, zeby dalo sie je zdjac niezaleznie.
  //
  // 1) SPRZATANIE PO KODZIE
  //    AOV.ai dorzuca prezent jako zwykla pozycje koszyka wycenona na 0 zl. Kiedy
  //    kod znika, aplikacja NIE usuwa tej pozycji - zostaje i zaczyna kosztowac
  //    (mgielka: 0,00 -> 17,99 zl). Klient zaplaciby za cos, czego nie wybieral.
  //    Zapamietujemy wiec darmowe pozycje przed czyszczeniem i po nim odejmujemy
  //    dokladnie tyle sztuk, ile bylo gratisem. Szukamy po variant_id, bo klucz
  //    linii zmienia sie razem z cena, a odejmujemy ze wspolnej puli - inaczej
  //    klient, ktory ten sam produkt kupil takze platnie, stracilby swoja sztuke.
  //
  // 2) DOPILNOWANIE OTWARCIA SZUFLADY
  //    Stare kopie ATC wklejone w szablonach emituja cart:refresh, na co motyw
  //    przeladowuje sekcje szuflady i kasuje jej stan otwarcia. Zmierzone na live:
  //    otwarcie w 2120 ms, zamkniecie przez motyw w 2456 ms. Ponowne przejscie
  //    natywna sciezka (klik w kotwice) trwa kolejna sekunde, wiec tutaj ustawiamy
  //    atrybuty wprost - focus i blokada przewijania sa juz z pierwszego otwarcia.
  function API() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function czekaj(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function koszyk() { return fetch(API() + 'cart.js').then(function (r) { return r.json(); }); }

  function ustawKod(kod) {
    return fetch(API() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: kod })
    }).then(function (r) { return r.json(); });
  }

  function zdejmijKodIPrezenty() {
    var pula = {};   // variant_id -> ile sztuk bylo darmowych

    return koszyk()
      .then(function (c) {
        (c.items || []).forEach(function (i) {
          if (i.final_line_price === 0) {
            pula[i.variant_id] = (pula[i.variant_id] || 0) + i.quantity;
          }
        });
        return ustawKod('');
      })
      // aplikacja przelicza koszyk z opoznieniem - bez tego zobaczylibysmy stary stan
      .then(function () { return czekaj(2000); })
      .then(koszyk)
      .then(function (c) {
        var zmiany = [];
        (c.items || []).forEach(function (i) {
          var zostalo = pula[i.variant_id];
          if (!zostalo) return;
          var zabierz = Math.min(zostalo, i.quantity);
          pula[i.variant_id] = zostalo - zabierz;      // pula sie wyczerpuje
          if (zabierz > 0) zmiany.push({ id: i.key, quantity: i.quantity - zabierz });
        });
        return zmiany.reduce(function (poprzednie, z) {
          return poprzednie.then(function () {
            return fetch(API() + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify(z)
            });
          });
        }, Promise.resolve());
      })
      .then(function () {
        if (window.RoutinesKoszyk && window.RoutinesKoszyk.odswiez) {
          return window.RoutinesKoszyk.odswiez();
        }
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: {} }));
      })
      .catch(function () {});
  }

  // Przejmujemy klikniecie w krzyzyk, zanim zrobi to szuflada. Dlatego ten plik
  // musi byc wpiety PRZED routines-cart-bar.js (patrz js-head.liquid).
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var usun = e.target.closest('[data-rcb-kod-usun]');
    if (!usun) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    zdejmijKodIPrezenty();
  }, true);

  // ---- dopilnowanie otwarcia -------------------------------------------------
  function otworzTwardo() {
    var d = document.getElementById('CartDrawer');
    if (!d || d.hasAttribute('open')) return;
    d.setAttribute('open', '');
    d.setAttribute('open-dialog', '');
    document.documentElement.classList.add('no-scroll');
  }

  var pilnujDo = 0;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || f.getAttribute('id') !== 'custom-atc-form') return;
    // okno, w ktorym wolno nam poprawiac motyw - liczone od wyslania formularza
    pilnujDo = Date.now() + 6000;
  }, true);

  // Kiedy motyw zamknie szuflade w trakcie swojego przeladowania, otwieramy ja
  // z powrotem. Poza oknem 6 s nie ruszamy nic - zamkniecie przez klienta zostaje.
  var drawer = document.getElementById('CartDrawer');
  if (drawer && window.MutationObserver) {
    new MutationObserver(function (muts) {
      if (Date.now() > pilnujDo) return;
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].attributeName !== 'open') continue;
        if (drawer.hasAttribute('open')) continue;   // wlasnie otwarta - nic nie robimy
        setTimeout(otworzTwardo, 120);
        return;
      }
    }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
  }

  window.RoutinesKodySprzatanie = { zdejmij: zdejmijKodIPrezenty, otworzTwardo: otworzTwardo };
})();
